import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### メッセージ送信の返信 API 操作クラス
 */
export default class WaiterSendMessageReplies {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET WaiterSendMessageRepliesFacilityUnread
   */
  public async getUnreadInFacility(userStore: LoginUser): Promise<WaiterSendMessageRepliesUnreadModel> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterSendMessageRepliesUnreadInFacility, formatParams);
    const response = await this.commonService.executeGet<WaiterSendMessageRepliesUnreadModel>(userStore, requestUrl, this.constructor.name, null, HitomeqErrorType.IGNORE, 0);

    return response.data;
  }

  /**
   * GET WaiterSendMessageRepliesUnread
   */
  public async getUnread(userStore: LoginUser, datetime: number): Promise<WaiterSendMessageRepliesUnreadModel> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      datetime: datetime
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterSendMessageRepliesUnread, formatParams);
    const response = await this.commonService.executeGet<WaiterSendMessageRepliesUnreadModel>(userStore, requestUrl, this.constructor.name, null, HitomeqErrorType.IGNORE, 0);

    return response.data;
  }
}

/**
 * ### 施設のメッセージ送信の返信未読が存在するか否か
 */
export interface WaiterSendMessageRepliesUnreadModel {
  /** 未読の返信メッセージがあるか否か */
  unread: boolean;
}
